import React from 'react';
import BigHeader from '../../components/BigHeader';
import Container from 'react-bootstrap/Container';


const Description = () => {
    return (
        <div>
            <BigHeader headerText={"Description"} backgroundImage={"https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg"}/>
            <Container style={{marginLeft: '50px', marginBottom: '100px', marginTop: '8px', alignItems: 'stretch', marginRight:'50px'}} >
            <div className="page-body">
			<p id="1dded58a-4733-43da-b917-6c6a4f4200e3" className=""><strong>Background</strong></p>
			<p id="1052b2f2-9c08-41bf-a07c-0b6c7d744645" className="">Sexual health is still a huge public health issue
				worldwide. Sexually transmitted infections (STIs) are a large contributor to this problem. Whether it is
				the alarming incidence (1 million new sexually transmitted infections every day), the prevalence (80% of
				sexually active individuals will acquire human papillomavirus by 45) or its disease burden (82,000
				deaths in 2019 from hepatitis B), the statistics are dire. For more information, take a look at the <a
					href="https://static.igem.wiki/teams/4602/wiki/laure-bubbles-folder/statistics/statistics.pdf">compiled
					statistics</a>. If you are new to the field of sexual health, you can also download our introductory
				guide <a href="https://static.igem.wiki/teams/4602/wiki/sexual-health-guide.pdf">here</a>. </p>
			<p id="c8750beb-340f-4822-ad26-182eb959a7ae" className="">
			</p>
			<p id="a109bbab-c66a-481f-8ce3-bcbe09fa1e2b" className="">With the vision in mind that a positive approach to
				sexuality and sexual health are key to the flourishing of a human life, our iGEM team wanted to
				contribute to developing solutions to the infectious issues at hand.</p>
			
              <p>     
			  </p>
			<p id="a241f4bb-a0d6-493d-9be2-21319f6c48d2" className="">
			</p>
			<p id="47eccd90-9701-428f-912f-042d28c8c84f" className="">
				<strong><strong><strong><strong><strong><strong><strong><strong><strong><strong><strong><strong><strong><strong><strong>Current
																			trends</strong></strong></strong></strong></strong></strong></strong></strong></strong></strong></strong></strong></strong></strong></strong>
			</p>
			<p id="aa992cb8-b48b-4eb4-9484-891cb6402f14" className="">At date, diagnostic technologies exist. Their use is
				mainly limited by logistics &amp; accessibility. When it comes to <strong>preventative biomedical
					innovation</strong> in the field of sexual health, the field has been <strong>stagnating</strong>
				since the implementation of pre-exposure prophylaxis in link with the development of antiretrovirals at
				the turn of the 20th century. It also remains HIV-biased and unprepared for future disease [x]
				epidemics. The field of microbicides has <strong>over the last 15 years</strong> attempted to provide
				users with an alternative to condoms and abstinence, taking into account groups specifically vulnerable
				to infection such as women, men who have sex with men, and sex workers. There has been <strong>no major
					game-changer for safe sex and STI reduction</strong>. You can download our benchmark of the subject
				<a href="https://static.igem.wiki/teams/4602/wiki/benchmark.pdf">here</a>. </p>
			<figure className="block-color-gray_background callout" style={{whiteSpace:'pre-wrap', display:"flex"}}
				id="4206c4de-5d1d-4239-8e6f-7f342e861008">
				<div style={{fontSize:"1.5em"}}><span className="icon">💡</span></div>
				<div style={{width:"100%"}}><strong>Disease X </strong>is not a specific disease, but rather a placeholder
					term used by the World Health Organization (WHO). It refers to an unknown or unexpected disease that
					may arise in the future and threaten the global public health.</div>
					<img alt="unkonsn" src="https://static.igem.wiki/teams/4602/wiki/pipeline-gifs/unknown.png" style={{ width: '200px' }} />
			</figure>
			<p id="7e75822e-2c2b-49aa-a7b1-391e8ac5b9dd" className="">
			</p>
			<p id="57ff300c-b12d-46d0-b2ed-68abbfb49396" className="">
				<strong><strong><strong><strong><strong>Lubritect</strong></strong></strong></strong></strong></p>
			<p id="f5e8d84b-b5e9-4ce2-9b9b-b8ff400ece9a" className="">This is why we decided to build a product that could
				answer this need. Lubritect leverages the power of <strong>naturally occurring lubricant</strong>,
				mucin, and the <strong>generative power of AI</strong>, to inform a product that is safe, effective and
				easy to handle. We combine a mucin-based hydrogel, which has been shown to reduce transmission rates of
				HIV and HSV [2] with <strong>AI-generated protein structures</strong> designed through RF-diffusion, to
				bind to surface proteins of the target pathogens. This approach potentially circumvents the evolution of
				pathogenic escape mechanisms by using protein structures not found in nature [1]. This way, we hope to
				generate a personal lubricant product which can entrap pathogens, significantly reducing their
				transmissibility. </p>
			<figure id="928bf44a-cc1d-4e79-8d05-41f392d1299c" className="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/images/banner.png"><img style={{width: '720px', height:"auto"}}alt='banner'
						src="https://static.igem.wiki/teams/4602/wiki/images/images/banner.png" /></a></figure>
			<p id="01cf00ef-474f-40ca-bd69-c9c1256fce39" className="">
			</p>
			<p id="c6b35155-8b89-4b4e-b82c-088d4e735641" className="">The freedom to design <strong>de novo
					proteins</strong> for a plethora of target pathogens allows us to provide a modular product,
				potentially not limited to the species or even domain of pathogens, be it bacterial, viral, or fungal.
				The <strong>modularity of our design</strong> (i.e. the fact we can add proteins against any target
				pathogens) allows for agility &amp; creativity in the fact of new infectious threats. </p>
				<div style={{ marginBottom: '1em' }}></div>
			<p id="fd99fb39-38fb-4d2e-ab63-d94f09bc2a90" className="">
			</p>
			<div style={{ margin: '1em 0' }}></div>
			<p id="937b514a-79c3-4712-9171-fea17e6b89d6" className=""><div style={{ margin: '1em 0' }}></div><strong><strong><strong><strong><strong>Conclusions</strong></strong></strong></strong></strong></p>
			<p id="38d095eb-bb43-467c-89e5-a341271726b3" className="">
  Lubritect is a game changer for safe-sex.
</p>
<p id="2c3cbe6d-efc7-4191-995d-312571a497c8" className="">
  Stemming from a <a href="https://2023.igem.wiki/paris-bettencourt/human-practices">broad reflexive human practice,</a> we moved into the design of a product that could address a real-word need (preventative tool against STIs for safe & pleasurable sex, complementary to condoms).
</p>
<p id="c8776c00-e844-4067-86ec-1056717ae2f4" className="">
  In order to inform the development of our proof of concept, we ground our research into two theoretical models:
</p>
<ul id="ffab5361-af6e-4b99-90ac-1dc6f981d136" className="bulleted-list">
  <li style={{ listStyleType: 'disc' }}>
    A <a href="https://2023.igem.wiki/paris-bettencourt/model#mathematical">mathematical model</a>, focused on physical properties of binding proteins and their ability to halt diffusion of pathogens.
  </li>
</ul>
<ul id="8f1f8b3f-08fa-4b86-89fd-7462cacb6c8b" className="bulleted-list">
  <li style={{ listStyleType: 'disc' }}>
    The <a href="https://2023.igem.wiki/paris-bettencourt/model#silico"><em>de novo </em></a>
    <a href="https://2023.igem.wiki/paris-bettencourt/model#silico">generation of protein binder candidates</a> by a very recent AI-based method (RF-diffusion), supplemented by docking simulations.
  </li>
</ul>
<p id="850ae98e-5f94-44c9-89f9-fd84b5faf018" className="">
  This enabled us to then express, purify and analyse these <em><em><em><em><em><em><em><em>de novo </em></em></em></em></em></em></em></em>proteins in <a href="https://2023.igem.wiki/paris-bettencourt/design">the lab</a> and assess efficacy of our mucin basis. To date, <a href="https://2023.igem.wiki/paris-bettencourt/results">verified binding</a> of two out of three mucin binders that we tested. We also have results suggesting that 3 out of 33 T4 bacteriophage binding proteins show phage binding and retention in solution.
</p>
<p id="eb0a538a-d7c3-4fb3-9bbf-45682a707933" className="">
  Convinced by the potential of the technology we are developing, our ultimate endeavour was to devise an <a href="https://2023.igem.wiki/paris-bettencourt/entrepreneurship">entrepreneurship plan</a> which matches our product’s full potential.
</p>
<p id="56539970-c31a-4de7-8c03-8bc0dfcc54b8" className=""></p>
			<p id="c334210a-716a-406d-9b17-1364e46e342b" className=""> </p>
			<p id="56539970-c31a-4de7-8c03-8bc0dfcc54b8" className="">
			</p>
			<p id="3d093fdb-68e9-4163-8609-b7858c0c416c" className="">[1] Watson, J. L., Juergens, D., Bennett, N. R.,
				Trippe, B. L., Yim, J., Eisenach, H. E., Ahern, W., Borst, A. J., Ragotte, R. J., Milles, L. F., Wicky,
				B. I. M., Hanikel, N., Pellock, S. J., Courbet, A., Sheffler, W., Wang, J., Venkatesh, P., Sappington,
				I., Torres, S. V., Lauko, A., … Baker, D. (2023). De novo design of protein structure and function with
				RFdiffusion. <em>Nature</em>, <em>620</em>(7976), 1089–1100. https://doi.org/10.1038/s41586-023-06415-8
			</p>
			<p id="63db7067-1f7c-4294-87cf-8fb583bb9199" className="">
			</p>
			<p id="be00a9da-6a8c-4620-924a-4d66b6be4824" className="">[2] Kretschmer, M., Ceña-Diez, R., Butnarasu, C.,
				Silveira, V., Dobryden, I., Visentin, S., Berglund, P., Sönnerborg, A., Lieleg, O., Crouzier, T., &amp;
				Yan, H. (2022). Synthetic Mucin Gels with Self-Healing Properties Augment Lubricity and Inhibit HIV-1
				and HSV-2 Transmission. <em>Advanced science (Weinheim, Baden-Wurttemberg,
					Germany)</em>, <em>9</em>(32), e2203898. https://doi.org/10.1002/advs.202203898</p>
			<p id="8e614834-a070-4bb4-9666-4b0931151536" className="">
			</p>
		</div>
            </Container>
        </div>
    )
}
export default Description;
